import { useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../../CONSTANTS";

function ProfilePersonalDetails({ show, onClose, user }) {
    
  const [formData, setFormData] = useState({
    name: user?.name || '',
    surname: user?.surname || '',
    dateOfBirth: user?.dateOfBirth || '',
    email: user?.email || '',
    phone: user?.phone || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      
      const response = await axios.put(`${CONSTANTS.API_URL}users/update/personal-details/${user._id}`, formData, {
        headers: {
            token: 'Bearer ' + user.accessToken,
          },
      });
      console.log(response.data);
      // Get the current user object from localStorage
      const storedUser = JSON.parse(localStorage.getItem(CONSTANTS.SESSION_COOKIE));

      // Update only the specific fields
      const updatedUser = {
        ...storedUser,
        name: response.data.name,
        surname: response.data.surname,
        dateOfBirth: response.data.dateOfBirth,
        email: response.data.email,
        phone: response.data.phone,
      };

      // Save the updated object back to localStorage
      localStorage.setItem(CONSTANTS.SESSION_COOKIE, JSON.stringify(updatedUser));
      toast.success("Profile updated successfully!");
      onClose(); // Close modal after success
    } catch (error) {
      console.error(error);
      toast.error("Failed to update profile.");
    }
  };

  if (!show) return null;

  return (
    <div className="modal modal-dialogue-outer fade show d-block" tabIndex="-1" role="dialog">
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal-dialog modal-dialogue-a4 modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Personal Details</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body md-space">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" name="name" value={formData.name} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label className="form-label">Surname</label>
                <input type="text" className="form-control" name="surname" value={formData.surname} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label className="form-label">Date of Birth</label>
                <input type="date" className="form-control" name="dateOfBirth" value={formData.dateOfBirth} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} />
              </div>

              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input type="tel" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
              </div>

              <button type="submit" className="btn btn-main">Save Changes</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfilePersonalDetails;
